import axios from 'axios';

export const fetchRoleFeature = async (id) => {
  var data = {
    RoleId: parseInt(id),
  }
  try {
    const response = await axios.post(`/api/RoleFeature/GetRoleFeatureById`,data);
    if (response && response.status === 200) {
      return response.data;
    } else {
      return response.status;
    }
  } catch (error) {
    if (error.response.status === 401) {
      return error.response.status;
    } else {
      let exceptionData = { expmessage: error.response.data.title, expstring: true }
      return exceptionData;
    }
  }
}

export const saveRoleFeature = async (values) => {
  let response;
  let result = { 
    roleId : parseInt(values.roleKey),
    roleFeatures : values.roleFeatures 
  };
    response = axios.post('/api/roleFeature/Create',result)
    .then(response => {
      return response;
    })
    .catch(error => {
      return error;
    });
  return response;
}

